/**
 * Constantes globales del juego. Centralizar estos valores evita "numeros magicos"
 * dispersos por el codigo y facilita ajustar el look & feel desde un solo lugar.
 */

export const GAME_TITLE = 'Maia Eyekon';

/** Resolucion logica de diseño. El juego se escala a la pantalla manteniendo esta base. */
export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

/** Claves de las escenas. Usar constantes evita errores de tipeo al navegar entre escenas. */
export const SceneKeys = {
  Boot: 'BootScene',
  Preload: 'PreloadScene',
  Hub: 'HubScene',
} as const;

export type SceneKey = (typeof SceneKeys)[keyof typeof SceneKeys];

/** Paleta de colores del juego (estilo K-pop: vibrante y luminoso). */
export const Palette = {
  background: 0x1a1033,
  backgroundAlt: 0x2d1b4e,
  primary: 0xff5fa2,
  secondary: 0x7c4dff,
  accent: 0x4dd0e1,
  highlight: 0xffd54f,
  textLight: '#ffffff',
  textDark: '#1a1033',
} as const;

/** Clave usada para persistir el progreso del jugador en el almacenamiento local. */
export const SAVE_KEY = 'maia-eyekon:player-profile:v1';
